import React from 'react'
import { Box, Container, Divider } from 'pcln-design-system'
import ScrollableDealModule from '../ScrollableDealModule'
import useFetchPackages, {
  PACKAGE_DISPLAY_MINIMUM
} from '../CustomHooks/useFetchPackages'
import useGeoPosition from '../CustomHooks/useGeoPosition'
import DealCarouselLoader from '../DealCarouselLoader'

const PackagesCarousel = ({
  heading = "Don't miss these package deals",
  headingMobile = "Don't miss these deals"
}) => {
  const { longitude, latitude } = useGeoPosition()
  const { deals, didFetchSucceed } = useFetchPackages({ latitude, longitude })

  return didFetchSucceed ? (
    <Box>
      <Container maxWidth={1280}>
        <Box px={3} pb={5} pt={4}>
          {deals.length >= PACKAGE_DISPLAY_MINIMUM ? (
            <ScrollableDealModule
              content={{
                heading,
                headingMobile,
                dataArray: deals
              }}
              handleNavOnClick={(href: string) => window.open(href)}
            />
          ) : (
            <DealCarouselLoader />
          )}
        </Box>
      </Container>
      <Divider m={0} />
    </Box>
  ) : null
}

export default PackagesCarousel
